// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pdokT","link":"Footer_link__YjJes","icon":"Footer_icon__qsoeX"};